import { useContext } from "react";
import React from "react";
import TadobaContext from "./Context/TadobaContext";
const NavigationBar = () => {
  const api = useContext(TadobaContext);
  const expandHandler = () => {
    api.setExpanded(true);
  };

  return (
    <div className="Nav">
      <ul className="Nav_item1">
        <li className="menu" onClick={expandHandler}>
          <img
            className="menu_img"
            src={require("../Assets/Icons/menu.png")}
            alt=""
          />
        </li>
        <li>
          <img
            className="forest_img"
            style={{ marginLeft: "10px", marginTop: "-7px" }}
            src={require("../Assets/Images/pench_logo.png")}
          />
        </li>
        <li>
          <div className="Nav_item1_text" style={{ marginTop: "-5px" }}>
            <span>Pench Tiger Reserve</span>
          </div>
          {/* {window.location.pathname === "/" && api.user.length === 0 && (
            <div className="Nav_item1_text">
              <span style={{ fontSize: "12px", fontWeight: "5px" }}>
                A Sanctuary for Safeguarding Your Data.
              </span>
            </div>
          )} */}
        </li>
      </ul>
      <ul className="Nav_item2">
        <li>
          <div className="Nav_item2_text">
            <span>Powered By</span>
          </div>
        </li>
        <li>
          <img
            className="forest_img_2"
            src={require("../Assets/Images/logo.png")}
          />
        </li>
      </ul>
    </div>
  );
};

export default NavigationBar;
